export default __webpack_public_path__ + "static/media/SemanaNordica_Agenda_Lunes_scroll.22da9c32.png";